import React, { useState } from 'react';
import classes from './Authentication.module.css';
import { auth, googleProvider } from '../config/firebase';
import { createUserWithEmailAndPassword, signInWithPopup, updateProfile, signInWithEmailAndPassword } from 'firebase/auth';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Loader from './Loader';

const AuthenticationModal = () => {

    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [showSignIn, setShowSignIn] = useState(false);
    const [showSignUp, setShowSignUp] = useState(true);

    const toggleHandler = () =>{
        setShowSignIn((prev)=> !prev);
        setShowSignUp((prev)=> !prev);
    }

    const registrationHandler = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            const response = await createUserWithEmailAndPassword(auth, email, password);
            await updateProfile(response.user, {
                displayName: userName
            });
            toast.success("Registed Successfully");
            toggleHandler();

            setLoading(false);
               
        } catch (error) {
            setLoading(false);

            if (!email.includes('@') || !email.includes('gmail.com')) {
                toast.error("Registration failed, Check your email");
            }
            else if (password.length < 8) {
                toast.error("Registration failed, Your password must be at least 8 characters long");
            }
            else {
                toast.error("Registration failed, Something went wrong");
            }
        }
    }

    const loginHandler = async (event) => {
        event.preventDefault();
        setLoading(true);

        try {
            await signInWithEmailAndPassword(auth, email, password);
            toast.success("Welcome to Coding Universe");

            setLoading(false);

        } catch (error) {
            setLoading(false);
            toast.error("Login failed. Please check your credentials.");
        }
    }

    const signInWithGoogleHandler = async () => {
        setLoading(true);
        try {
            await signInWithPopup(auth, googleProvider);
            toast.success("Welcome to Coding Universe");
            setLoading(false);

        } catch (error) {
            setLoading(false);
            toast.error("Login failed. Please check your credentials.");
        }
    }

    return (

        <>
            <ToastContainer position="top-right" autoClose={3000} />

            {loading && <Loader></Loader>}

            {showSignUp && <div className={classes.mainForm}>
                <div className={classes.top}>
                    <form onSubmit={registrationHandler} className={classes.form}>
                        <h2>SignUp</h2>

                        <input type="text" placeholder='User name' onChange={(e) => { setUserName(e.target.value) }} />
                        <input type="text" placeholder='Email' onChange={(e) => { setEmail(e.target.value) }} />
                        <input type="password" placeholder='Password' onChange={(e) => { setPassword(e.target.value) }} />

                        <button type="submit" > Create Account </button>
                        <h3 onClick={toggleHandler}>Already have a account? <span>Log in</span></h3>
                    </form>
                </div>
            

                <div><hr /></div>

                <div className={classes.bottom}>
                    <button className={classes.google} onClick={signInWithGoogleHandler}> <img src={'https://cdn-icons-png.flaticon.com/128/281/281764.png'} alt="" /> Continue With Google</button>
                </div>
            </div> }

            {showSignIn && <div className={classes.mainForm}>

                <div className={classes.top}>
                    <form className={classes.form} onSubmit={loginHandler} >
                        <h2>Welcome back</h2>
                        <input type="email" placeholder='Email address' onChange={(e) => { setEmail(e.target.value) }} />
                        <input type="password" placeholder='Password' onChange={(e) => { setPassword(e.target.value) }} />

                        <button type="submit" >Log In </button>
                        <h3 onClick={toggleHandler}>Don't have an account? <span>Sign up</span></h3>

                    </form>
                </div>

                <div><hr /></div>

                <div className={classes.bottom}>
                    <button className={classes.google} onClick={signInWithGoogleHandler}> <img src={'https://cdn-icons-png.flaticon.com/128/281/281764.png'} alt="" /> Continue With Google</button>
                </div>
            </div>}
        </>
    )
}

export default AuthenticationModal;